<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8L8 12L12 8"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
